import {defineStore} from 'pinia';

export const useProductStore = defineStore('productStore', {
    state: () => ({
        product: {
            price: null,
        },
        images: null,
        collectionProduct: [],
        loadings: {
            imagesLoading: true,
            collectionProductLoading: true,
        },
    }),
    actions: {
        loadImages() {
            this.loadings.imagesLoading = true

            axios.post('/axios/generate-image-url', {
                id: this.product.id,
            }).then(response => {
                this.images = response.data
                this.loadings.imagesLoading = false
            }).catch(error => {
                this.loadings.imagesLoading = false
            })
        },
        getCollectionProducts() {
            if (this.product.collections === undefined && this.product.collections[0] === undefined) {
                this.loadings.collectionProductLoading = false
                return
            }

            this.loadings.collectionProductLoading = true

            axios.post('/axios/collection/product-by-collection', {
                id: this.product.collections[0].id,
            }).then(response => {
                this.collectionProduct = response.data.tiles.products ?? []
                this.loadings.collectionProductLoading = false
            }).catch(error => {
                this.loadings.collectionProductLoading = false
            })
        }
    }
});
